
/* injects from baggage-loader */

'use strict';

import { FormTypes, FormSizes } from '_appRoot/index.const';

import StageBaseController from '../stage-base.controller';

import { shuffle } from 'lodash';

import { balloonsFirst, balloonsDone } from './stage-sixth.const';

export default class StageSixthController extends StageBaseController{
    constructor($log, $state, $Forms, Dialog, Session, Trophies) {
        'ngInject';
        super($log, $state, $Forms, Dialog, Session, Trophies);
        this.title = 'Responda as Perguntas conforme a imagem';
        this.name = 'Stage 6';
        
        this.forms = {
            group1: [],
            group2: [],
            group3: []
        }

        this.questions = {
            f1: {
                q1: {
                    value: null,
                    error: false
                },
                q2: {
                    value: null,
                    error: false
                },
                q3: {
                    value: null,
                    error: false
                },
                q4: {
                    value: null,
                    error: false
                }               
            },
            f2: {
                q1: {
                    value: null,
                    error: false,
                    answer: null,
                    errors:[]
                },
                q2: {
                    value: null,
                    error: false,
                    answer: null,
                    errors:[]
                }
            }
        } 
    }

    $onInit(){
        this.stages = this.Session.get().stages;
        super.$onInit();


        this.createForms();
    }

    createForms(){
        let types = Object.values(FormTypes);
        let colors = [1,2,3]; 

        colors = shuffle(colors);
        types = shuffle(types);
        
        let bool = !!Math.floor(Math.random() * 2);
        

        let firstNumRand = Math.floor((Math.random() * 3) + 3);
        let secondNumRand = Math.floor((Math.random() * 3) + 3);
        let thirdNumRand = Math.floor((Math.random() * 3) + 3);

        
        if(bool){
            if(firstNumRand === secondNumRand+thirdNumRand && types[2]===2){
                firstNumRand++;
            }
            this.forms.group1 = this.$Forms.create(types[0], FormSizes.small, colors[0], firstNumRand);
            this.forms.group2 = this.$Forms.create(types[1], FormSizes.small, colors[0], secondNumRand);
            this.forms.group3 = this.$Forms.create(types[1], FormSizes.small, colors[1], thirdNumRand);
        }else{
            if(firstNumRand+secondNumRand === thirdNumRand && types[2]===2){
                thirdNumRand++;
            }
            this.forms.group1 = this.$Forms.create(types[0], FormSizes.small, colors[0], firstNumRand);
            this.forms.group2 = this.$Forms.create(types[0], FormSizes.small, colors[1], secondNumRand);
            this.forms.group3 = this.$Forms.create(types[1], FormSizes.small, colors[1], thirdNumRand);
        }
    }    

    onSuccess() {
        
        let totalCollected = 1;
        this.Session.updateStage(this.name, { totalCompleted: 3 });
        
        if(!this.stages[5].completed){
            
                    this.Dialog.showInterventionalTrophiesModal(totalCollected, () => {
                        this.Dialog.showInterventionalModal("Winner",balloonsFirst);
                        this.Session.updateStage(this.name, { completed: true });
                        this.$state.go('main.stage-seventh');
                    });
                }else{
            
                    this.Dialog.showInterventionalModal("Winner",balloonsDone);
                    this.Session.updateStage(this.name, { completed: true });
                    this.$state.go('main.stage-seventh');
                }
    }    
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-sixth/stage-sixth.controller.js